export default __webpack_public_path__ + "static/media/logo-governo-horizontal-branca.cedb5ed1.svg";